import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

// En producción, usar URLs relativas para que nginx haga el proxy correctamente
// Esto funciona tanto en SHARED (app.lyrax.cl) como DEDICATED (protectora.lyrax.cl)
const API_BASE_URL = import.meta.env.PROD
  ? '/api'  // Producción: usar URL relativa (nginx proxea a backend)
  : (import.meta.env.VITE_API_URL || 'http://lyrax.localhost:3001/api'); // Desarrollo: usar env o localhost

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2 minutos para cargas grandes (ej: paginación múltiple en Payku)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response.data,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error.response?.data || error.message);
  }
);